import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot } from "vue"
import _imports_0 from '@/assets/img/envo-icon-post/defualt-tx.png'
import _imports_1 from '@/assets/img/envo-icon-post/reply.svg'


const _hoisted_1 = { class: "comment_item" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "commentInfo" }
const _hoisted_4 = { class: "user-info" }
const _hoisted_5 = { class: "name" }
const _hoisted_6 = {
  key: 0,
  src: _imports_1
}
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { class: "date" }
const _hoisted_9 = { class: "content" }
const _hoisted_10 = { class: "txt" }

import i18n from '@/language';


export default /*@__PURE__*/_defineComponent({
  __name: 'commentItem',
  props: ["txSixe", "data"],
  setup(__props) {

const props = __props;

const formatTime = (date: any) => {
  let lowYear = new Date(date).getFullYear()
  let lowMonth = new Date(date).getMonth()
  let lowDay = new Date(date).getDate()
  let lowHours = new Date(date).getHours()
  let lowMinutes = new Date(date).getMinutes()
  let lowSeconds = new Date(date).getSeconds()

  let lowDate = new Date(date).getTime();
  let newDate = new Date().getTime();
  let second = (newDate - lowDate) / 1000;
  let minute = (newDate - lowDate) / 1000 / 60;
  let hour = (newDate - lowDate) / 1000 / 60 / 60;
  let day = (newDate - lowDate) / 1000 / 60 / 60 / 24;
  // let month = (newDate - lowDate) / 1000 / 60 / 60 / 24 / 30;
  if (second > 60) {
    if (minute > 1 && minute < 3) {
      return i18n.global.t('FZQ', { data: 1 })
    }
    if (minute > 3 && minute < 10) {
      return i18n.global.t('FZQ', { data: 3 })
    } else if (minute > 10 && minute < 30) {
      return i18n.global.t('FZQ', { data: 10 })
    } else if (minute > 30 && minute < 60) {
      return i18n.global.t('FZQ', { data: 30 })
    } else if (hour > 1 && hour < 3) {
      return i18n.global.t('XSQ', { data: 1 })
    } else if (hour > 3 && hour < 5) {
      return i18n.global.t('XSQ', { data: 3 })
    } else if (hour > 5 && hour < 10) {
      return i18n.global.t('XSQ', { data: 5 })
    } else if (hour > 10 && hour < 24) {
      return i18n.global.t('XSQ', { data: 10 })
    }
    else if (hour > 24 && day < 3) {
      return i18n.global.t('TQ', { data: 1 })
    }
    else if (day > 3 && day < 5) {
      return i18n.global.t('TQ', { data: 3 })
    }
    else if (day > 5) {
      return lowYear + "-" + lowMonth + "-" + lowDay;
    }
  } else {
    return i18n.global.t('GG')
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.data.portrait)
      ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          class: _normalizeClass({
      tx: true,
      smallTx: __props.txSixe == 'small'
    }),
          src: __props.data.portrait
        }, null, 10, _hoisted_2))
      : (_openBlock(), _createElementBlock("img", {
          key: 1,
          class: _normalizeClass({
      tx: true,
      smallTx: __props.txSixe == 'small'
    }),
          src: _imports_0
        }, null, 2)),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("span", _hoisted_5, [
          _createElementVNode("span", null, _toDisplayString(__props.data.displayName || "--"), 1),
          (__props.data.toName)
            ? (_openBlock(), _createElementBlock("img", _hoisted_6))
            : _createCommentVNode("", true),
          (__props.data.toName)
            ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(__props.data.toName || "--"), 1))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_8, _toDisplayString(formatTime(__props.data.createAt)), 1),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, _toDisplayString(__props.data.content), 1)
      ]),
      _renderSlot(_ctx.$slots, "comment")
    ])
  ]))
}
}

})